import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import { FaCalendarAlt } from 'react-icons/fa';
import { IoIosArrowDown } from 'react-icons/io';

const VLDatePicker = (props) => {
  const calender = useRef(null);

  return (
    <div style={styles.container}>
      <DatePicker
        ref={calender}
        showPopperArrow={true}
        className="vl-width-full vl-datePicker"
        dateFormat="dd/MM/yyyy"
        {...props}
        setOpen={true}
      />
      <a
        href="/"
        onClick={(e) => {
          e.preventDefault();
          calender.current.input.focus();
        }}
      >
        {!props.isTime && <FaCalendarAlt style={styles.calendarStyle} />}
        {props.isTime && <IoIosArrowDown style={styles.timeStyle} />}
      </a>
    </div>
  );
};

export { VLDatePicker };

const styles = {
  container: { display: 'flex' },
  calendarStyle: { color: 'var(--productPrimaryDark)', margin: '8px 4px 8px 9px' },
  timeStyle: { color: '#000000', margin: '8px 4px 8px 9px' }
};
